import React from "react";
import { Card, Typography, CardContent, CardActions } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import { useAuth } from "react-oidc-context";

import * as Styled from "./styles";

const MicrosoftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 21 21" fill="none">
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </svg>
);

const Login = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const isLoggingIn = auth.isLoading || !!auth.activeNavigator;

  const handleLogin = () => {
    auth.signinRedirect();
  };

  return (
    <Styled.Container>
      <Styled.ContainerContent>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card
            sx={{
              width: 360,
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            <CardContent>
              <Typography
                sx={{ fontSize: "1.5rem", fontWeight: 300 }}
                color="text"
                variant="inherit"
              >
                {t("loginTitle")}
              </Typography>
              <Typography
                sx={{ mb: 2, fontSize: "0.875rem", fontWeight: 300 }}
                color="text.secondary"
                variant="subtitle1"
              >
                {t("loginSubtitle")}
              </Typography>
              <Styled.ContainerFingerPrint />

              {auth.error && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{
                    mb: 2,
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                  }}
                >
                  Não foi possível concluir o login. Tente novamente.
                  {auth.error.message ? ` (${auth.error.message})` : ""}
                </Typography>
              )}

              <CardActions sx={{ padding: 0 }}>
                <LoadingButton
                  sx={{
                    my: 2,
                    padding: "8px 16px",
                    borderRadius: "40px",
                    gap: 1,
                    ...(isLoggingIn && {
                      color: "transparent",
                      "&.Mui-disabled": {
                        backgroundColor: "primary.main",
                        color: "transparent",
                      },
                      "& .MuiLoadingButton-loadingIndicator": {
                        color: "#fff",
                      },
                    }),
                  }}
                  onClick={handleLogin}
                  loading={isLoggingIn}
                  loadingPosition="center"
                  disabled={isLoggingIn}
                  fullWidth
                  size="small"
                  variant="contained"
                  startIcon={!isLoggingIn ? <MicrosoftIcon /> : undefined}
                >
                  {t("loginWithMicrosoft")}
                </LoadingButton>
              </CardActions>
            </CardContent>
          </Card>
        </Grid>
        <div>
          <Styled.ContainerBackground />
        </div>
      </Styled.ContainerContent>
    </Styled.Container>
  );
};

export default Login;
